export default __webpack_public_path__ + "static/media/i9.58dcc981.png";